import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconAdd = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 21 21"
      >
        <path
          fill={color}
          d="M10.5 16.334a.806.806 0 01-.594-.24.806.806 0 01-.24-.594v-4.166H5.5a.806.806 0 01-.594-.24.806.806 0 01-.24-.594c0-.236.08-.434.24-.593.16-.16.358-.24.594-.24h4.167V5.5c0-.236.08-.434.24-.593.159-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.357.24.593v4.167H15.5c.236 0 .434.08.594.24.16.16.24.357.24.593s-.08.434-.24.594a.806.806 0 01-.594.24h-4.167V15.5c0 .236-.08.434-.24.594a.806.806 0 01-.593.24z"
        ></path>
      </svg>
    </SvgWrapper>
  );
};

export default IconAdd;
